<template>
  <div>
    <div v-if="internalValue" class="detail-dialog-body">
      <div class="sub-container">
        <div class="sub-title d-flex justify-space-between" style="width: 100%;">
          <div>{{ `CMS: ${internalValue.nickname || ''} | ${internalValue.cmsId || ''}` }}</div>
          <div class="d-flex">
            <v-btn
              v-if="!internalValue.cmsId"
              class="ml-2"
              small
              outlined
              color="primary"
              @click.stop="$emit('save-member', {internalValue, idx})"
            >
              <v-icon
                small
              >
                mdi-content-save-outline
              </v-icon>
              저장
            </v-btn>
            <v-btn
              v-if="!internalValue.cmsId"
              class="ml-2"
              small
              outlined
              color="primary"
              @click.stop="$emit('cancel-member', {internalValue, idx})"
            >
              <v-icon
                small
              >
                mdi-content-save-outline
              </v-icon>
              취소
            </v-btn>
            <v-btn
              v-if="!!internalValue.cmsId"
              class="ml-2"
              small
              outlined
              color="primary"
              @click.stop="$emit('refresh-member', {internalValue, idx})"
            >
              <v-icon
                small
              >
                mdi-content-save-outline
              </v-icon>
              동기화
            </v-btn>
            <v-btn
              v-if="!!internalValue.cmsId"
              class="ml-2"
              small
              outlined
              color="primary"
              @click.stop="$emit('cancel-member', {internalValue, idx})"
            >
              <v-icon
                small
              >
                mdi-content-save-outline
              </v-icon>
              삭제
            </v-btn>
          </div>
        </div>
        <div class="custom-spacer" />
        <div class="sub-content-wrap">
          <table>
            <tr>
              <th>
                {{ internalValue.cmsId ? '납부자 상태' : '등록 방식' }}
              </th>
              <td>
                <template v-if="internalValue.cmsId">
                  {{ cmsResultMsg(internalValue) }}
                </template>
                <template v-else>
                  <label>
                    <input
                      v-model="internalValue.simpleYn"
                      type="radio"
                      :name="`simpleYn-${ id }`"
                      value="N"
                    >
                    일반
                  </label>
                  <label>
                    <input
                      v-model="internalValue.simpleYn"
                      type="radio"
                      :name="`simpleYn-${ id }`"
                      value="Y"
                    >
                    비대면
                  </label>
                </template>
              </td>
              <th>
                별칭
              </th>
              <td>
                <input
                  v-model="internalValue.nickname"
                  type="text"
                >
              </td>
              <th>
                업체
              </th>
              <td>
                <label>
                  <input
                    v-model="internalValue.serviceProvider"
                    type="radio"
                    :name="`internalValue.serviceProvider-${ id }`"
                    value="F"
                    :disabled="true"
                  >
                  효성
                </label>
                <label>
                  <input
                    v-model="internalValue.serviceProvider"
                    type="radio"
                    :name="`internalValue.serviceProvider-${ id }`"
                    value="N"
                  >
                  나이스
                </label>
              </td>
            </tr>
            <tr>
              <th>결제방법</th>
              <td>
                <label>
                  <input
                    v-model="internalValue.paymentKind"
                    type="radio"
                    :name="`internalValue.paymentKind-${ id }`"
                    value="C"
                  >
                  카드
                </label>
                <label>
                  <input
                    v-model="internalValue.paymentKind"
                    type="radio"
                    :name="`internalValue.paymentKind-${ id }`"
                    value="B"
                  >
                  계좌이체
                </label>
              </td>
              <th>
                {{
                  internalValue.paymentKind === 'B' ? '결제은행' : '카드유효기간'
                }}
              </th>
              <td>
                <select
                  v-if="internalValue.paymentKind === 'B'"
                  v-model="internalValue.bankCode"
                  :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                >
                  <option :value="null" disabled>
                    선택 안함
                  </option>
                  <option
                    v-for="bankItem in bankCodes"
                    :key="`bank-code-${bankItem.codeKey}`"
                    :value="bankItem.codeKey"
                  >
                    {{ bankItem.codeValue }}
                  </option>
                </select>
                <the-mask
                  v-else
                  v-model="internalValue.cardValidDate"
                  mask="##/##"
                  placeholder="MM/YY"
                  :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                />
              </td>
              <th>
                {{
                  internalValue.paymentKind === 'B' ? '계좌번호' : '카드번호'
                }}
              </th>
              <td>
                <the-mask
                  v-model="internalValue.paymentNumber"
                  :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                  :mask="internalValue.paymentKind === 'B' ?
                    '################################'
                    : '####-####-####-####'
                  "
                  placeholder="하이픈(-) 없이 입력"
                />
              </td>
            </tr>
            <tr>
              <th>납부자 유형</th>
              <td>
                <label>
                  <input
                    v-model="internalValue.payerType"
                    type="radio"
                    :name="`internalValue.payerType-${ id }`"
                    value="I"
                  >
                  개인
                </label>
                <label>
                  <input
                    v-model="internalValue.payerType"
                    type="radio"
                    :name="`internalValue.payerType-${ id }`"
                    value="B"
                  >
                  사업자
                </label>
              </td>
              <th>
                {{ internalValue.payerType === 'I' ? '생년월일' : '사업자 번호' }}
              </th>
              <td>
                <the-mask
                  v-model="internalValue.payerNumber"
                  :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                  :mask="internalValue.payerType === 'I' ? '##-##-##' : '###-##-#####'"
                  :placeholder="internalValue.payerType === 'I' ? 'YY-MM-DD' : '000-00-00000'"
                />
              </td>
              <th>
                동의서 첨부
              </th>
              <td>
                <input
                  v-show="false"
                  :id="`mcc_cms_reg_file_name-${ id }`"
                  :ref="`agreement_attach-${ id }`"
                  :accept="
                      internalValue.serviceProvider === 'N'
                        ? 'image/jpg,image/jpeg,image/gif,image/tif,application/pdf'
                        : 'image/*,application/pdf'
                    "
                  tabindex="2"
                  type="file"
                  @change="onAgreeFileSelectedCustom($event)"
                >
                <v-btn
                  dark
                  color="#0c98fe"
                  small
                  :disabled="internalValue.simpleYn === 'Y' || internalValue.paymentKind === 'C'"
                  @click.stop="$refs[`agreement_attach-${ id }`].click()"
                >
                  파일 선택
                </v-btn>
                <span>
                  <!--다운로드 -->
                    <v-tooltip bottom min-width="90px">
                      <template #activator="{ on }">
                        <v-btn
                          v-if="!!internalValue.fileName"
                          icon
                          color="#ccc"
                          style="color: #333"
                          v-on="on"
                          @click="fileDownload(internalValue)"
                        >
                          <v-icon small>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <div>
                        {{ '다운로드' | translate }}
                      </div>
                    </v-tooltip>
                  </span>
                <br>
                <div :title="fileName" class="agree_file_name">
                  {{ fileName }}
                </div>
              </td>
            </tr>
            <tr>
              <th>납부자 명</th>
              <td>
                <input
                  v-model="internalValue.payerName"
                  type="text"
                >
              </td>
              <th>납부자 연락처</th>
              <td>
                <the-mask
                  v-model="internalValue.payerPhone"
                  :mask="'###-####-####'"
                />
              </td>
              <th>이메일</th>
              <td>
                <input
                  v-model="internalValue.email"
                  :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                  type="text"
                >
              </td>
            </tr>
            <tr>
              <th>
                문자전송 여부
              </th>
              <td>
                <label>
                  <input
                    v-model="internalValue.smsYn"
                    :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                    type="radio"
                    :name="`internalValue.smsYn-${ id }`"
                    value="Y"
                  >
                  사용
                </label>
                <label>
                  <input
                    v-model="internalValue.smsYn"
                    :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                    type="radio"
                    :name="`internalValue.smsYn-${ id }`"
                    value="N"
                  >
                  미사용
                </label>
              </td>
              <th>
                현금영수증
              </th>
              <td>
                <label>
                  <input
                    v-model="internalValue.cashReceiptIssue"
                    :disabled="internalValue.simpleYn === 'Y'
                      || internalValue.paymentKind === 'C'
                    && !internalValue.cmsId"
                    type="radio"
                    :name="`internalValue.cashReceiptIssue-${ id }`"
                    value="Y"
                  >
                  발급
                </label>
                <label>
                  <input
                    v-model="internalValue.cashReceiptIssue"
                    :disabled="internalValue.simpleYn === 'Y'
                      || internalValue.paymentKind === 'C'"
                    type="radio"
                    :name="`internalValue.cashReceiptIssue-${ id }`"
                    value="N"
                  >
                  미발급
                </label>
              </td>
              <th>
                현금영수증 번호
              </th>
              <td>
                <the-mask
                  v-model="internalValue.cashReceiptNumber"
                  :disabled="
                    internalValue.paymentKind !== 'B'
                    || !internalValue.cashReceiptIssue
                    || (internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId)
                  "
                  :mask="[
                    '#',
                    '##',
                    '###',
                    '####',
                    '#####',
                    '######',
                    '#######',
                    '########',
                    '#########',
                    '##########',
                    '##########',
                    '###########',
                    '############',
                    '#############',
                    '##############',
                    '###############',
                    '################',
                  ]"
                />
              </td>
            </tr>
            <tr>
              <th>출금 일시 정지</th>
              <td>
                <label>
                  <input
                    v-model="internalValue.acctPause"
                    :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                    type="radio"
                    :name="`internalValue.acctPause-${ id }`"
                    value="Y"
                  >
                  사용
                </label>
                <label>
                  <input
                    v-model="internalValue.acctPause"
                    :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                    type="radio"
                    :name="`internalValue.acctPause-${ id }`"
                    value="N"
                  >
                  미사용
                </label>
              </td>
              <th rowspan="2">
                비고
              </th>
              <td colspan="3" rowspan="2" style="padding: 4px">
                <textarea
                  v-model="internalValue.memo"
                  :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                  style="height: 56px"
                />
              </td>
            </tr>
            <tr>
              <th>자동화 여부</th>
              <td>
                <label>
                  <input
                    v-model="internalValue.autoYn"
                    type="radio"
                    :name="`internalValue.autoYn-${ id }`"
                    value="Y"
                    :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                  >
                  사용
                </label>
                <label>
                  <input
                    v-model="internalValue.autoYn"
                    type="radio"
                    :name="`internalValue.autoYn-${ id }`"
                    value="N"
                    :disabled="internalValue.simpleYn === 'Y'
                    && !internalValue.cmsId"
                  >
                  미사용
                </label>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="custom-spacer" />
    </div>
  </div>
</template>

<script>
import time from "../../assets/plugins/mps-common/time";
import {cloneDeep} from "lodash";
import {PATH} from "@/constants";
import {DateTime} from "luxon";
import Label from "../label/Label.vue";
import {fileManager} from "@/assets/plugins/mps-common/file/file-manager";


export default {
  name: "CmsPlanSubItem",
  props: {
    value: {
      type: Object,
      default: undefined,
    },

    idx: {
      type: Number,
      default: undefined,
    },

    cmsBankCodes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      niceAgreeFileTypeValidArray: [
        'image/jpg',
        'image/jpeg',
        'image/gif',
        'image/tif',
        'image/tiff',
        'application/pdf',
      ],

      hsAgreeFileTypeValidArray: [
        'image/jpg',
        'image/jpeg',
        'image/gif',
        'image/tif',
        'image/tiff',
        'application/pdf',
        'image/png',
      ],

      internalValue: undefined,
    }
  },
  computed: {
    id() {
      return this.internalValue && this.internalValue.cmsMemberId ? this.internalValue.cmsMemberId : -1
    },

    bankCodes() {
      if (!this.cmsBankCodes || this.cmsBankCodes.length <= 0 || !this.internalValue || !this.internalValue.serviceProvider)
        return []

      return this.cmsBankCodes.filter(e => {
        if (this.internalValue.serviceProvider === 'F')
          return e.fmsYn === 'Y'
        else if (this.internalValue.serviceProvider === 'N')
          return e.niceYn === 'Y'
        else
          return true
      })
    },


    fileName() {
      return (
        (this.internalValue.agreeFile && this.internalValue.agreeFile.name) ||
        this.internalValue.fileOrgName ||
        ''
      )
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal)
          return
        this.internalValue = cloneDeep(newVal)
      }
    },

    internalValue: {
      deep: true,
      handler(newVal) {
        this.$emit('input', newVal)
      }
    },
  },

  methods: {


    cmsResultMsg(item) {
      if (!!item.agreementSimpleId &&
        !!item.agreementStatusYn && ['N','R'].includes(item.agreementStatusYn)) {
        return "납부자 정보 입력 대기중";
      } else if (item.acctPause === 'Y') return "일시정지";
      else if (item.procType !== 'D' && item.resultYn === 'Y') return "사용중";
      else if (item.procType === 'N' && (item.resultYn === 'R' || item.resultYn === 'P')) return "등록처리중";
      else if (item.procType === 'U' && (item.resultYn === 'R' || item.resultYn === 'P')) return "변경처리중";
      else if (item.procType === 'D' && (item.resultYn === 'R' || item.resultYn === 'P')) return "해지처리중";
      else if (item.procType === 'D' && item.resultYn === 'Y') return "해지";
      else if ((item.procType === 'N' || item.procType === 'U') && item.resultYn === 'N') return "등록실패";
      else if (!isNOU(item.resultMsg)) return item.resultMsg
      return "-";
    },


    /**
     * 동의서 첨부 저장 메소드(input file v-model 미지원)
     */
    onAgreeFileSelectedCustom(event) {
      if (this.internalValue.serviceProvider === 'N') {
        if (
          !this.niceAgreeFileTypeValidArray.includes(event.target.files[0].type)
        ) {
          return this.$alert('사용할 수 없는 형식의 파일입니다.')
        } else if (event.target.files[0].size > 300000) {
          return this.$alert('나이스CMS는 서면동의파일 300KB 크기제한입니다.')
        } else return this.setAgreementCustom(event.target.files[0])
      } else if (
        !this.hsAgreeFileTypeValidArray.includes(event.target.files[0].type)
      ) {
        return this.$alert('사용할 수 없는 형식의 파일입니다.')
      } else if (event.target.files[0].size > 5000000) {
        return this.$alert('효성CMS는 서면동의파일 5000KB 크기제한입니다.')
      } else return this.setAgreementCustom(event.target.files[0])
    },

    /**
     * 동의 자료를 설정합니다.
     * 동의 자료 등록 요청에 사용됩니다.
     */
    setAgreementCustom(file) {
      if (!file) {
        this.$alert(this.$translate('동의 자료 파일이 올바르지 않습니다.'))
      } else {
        this.internalValue.agreeFile = file
      }
    },
  },
}
</script>

<style scoped>
.detail-dialog-body {
  width: 100%;
}

.sub-container {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.sub-title {
  font-size: 16px;
  text-align: left;
  font-weight: bold;
  color: #333333;
}

.sub-content-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 32px;
}

.sub-content-item {
  display: flex;
  padding-right: 32px;
}

.sub-content-item.one-third {
  width: calc(100% / 3);
}

input,
select {
  flex: 1;
  margin-left: 16px;
  border-bottom: 1px solid #0c98fe;
  color: #1867c0;
  outline: none;
}

textarea {
  width: 100%;
  height: 100px;
  border: 1px solid #d0d0d0;
  resize: none;
}

input:disabled,
select:disabled {
  border-bottom: 1px solid #6f6f6f;
  color: #6f6f6f;
  background: #dddddd;
}
textarea:disabled {
  color: #6f6f6f;
  background: #dddddd;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  border-left: 1px solid #d0d0d0;
  border-top: 1px solid #d0d0d0;
  font-size: 12px;
}

table tr th {
  background: #0c98fe;
  padding: 2px 4px;
  color: white;
  text-align: right;
  width: 100px;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

table tr:nth-child(2n) {
  background: #f4f4f4;
}

table tr td {
  padding: 8px 4px;
  width: 200px;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

table tbody tr td input {
  width: 120px;
}

table tbody tr td:nth-child(1) {
  text-align: right;
}


/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>